import { createSelector } from 'reselect';
import { AnyStateWithExchange, LoadingType } from '../types';

const ALL_LOADING_EXCHANGE_TYPES: LoadingType[] = [
	'all',
	'exchange-variants',
	'exchange-price',
	'auto-create-exchange'
];

export const getIsLoadingState = (state: AnyStateWithExchange) => state.exchange.isLoading;

export const getIsLoadingExchange = createSelector(getIsLoadingState, loadingState =>
	ALL_LOADING_EXCHANGE_TYPES.includes(loadingState)
);

export const getIsLoadingByType = (loadingType: LoadingType) =>
	createSelector(getIsLoadingState, loadingState => loadingState === loadingType);
